import { ExplanationTypeEnum } from '@doltech/utils/lib/constants';
import { types as t } from 'mobx-state-tree';

import { CorrectOption } from '../../../../question-data-model/Question/CorrectOption/correct-option.store';
import { AdminDetailOnlyStore } from '../Explanation/_extends/admin-detail-only.store';
import { AdminListeningExplanationStore } from '../Explanation/_extends/admin-listening-explanation.store';
import { AdminLocatingDetailStore } from '../Explanation/_extends/admin-locating-diagram.store';
import { AdminMainIdeaStore } from '../Explanation/_extends/admin-main-idea.store';

const getExplanationModelFromType = (type: ExplanationTypeEnum) => {
  switch (type) {
    case ExplanationTypeEnum.MAIN_IDEA:
      return AdminMainIdeaStore;
    case ExplanationTypeEnum.LOCATING_DETAIL:
      return AdminLocatingDetailStore;
    case ExplanationTypeEnum.LISTENING_EXPLANATION:
      return AdminListeningExplanationStore;
    case ExplanationTypeEnum.DETAIL_ONLY:
      return AdminDetailOnlyStore;
    default:
      return AdminLocatingDetailStore;
  }
};

export const AdminCorrectOption = CorrectOption.named('AdminCorrectOption')
  .props({
    explanation: t.maybeNull(
      t.union(
        {
          dispatcher: (s) => {
            if (s) {
              return getExplanationModelFromType(s.type);
            }
            return AdminLocatingDetailStore;
          },
        },
        AdminMainIdeaStore,
        AdminLocatingDetailStore,
        AdminListeningExplanationStore,
        AdminDetailOnlyStore,
      ),
    ),
  })
  .actions((self) => ({
    initExplanation(type, input: any) {
      let detailExp;
      if (self.explanation) {
        detailExp = self.explanation.detailExplanation;
      }
      const ExplanationModel = getExplanationModelFromType(type);
      self.explanation = ExplanationModel.create({ type });
      self.explanation.init(input, detailExp);
    },
    setDetailExplanation(detailExplanation: any) {
      if (!self.explanation) {
        const type = ExplanationTypeEnum.DETAIL_ONLY;
        const ExplanationModel = getExplanationModelFromType(type);
        self.explanation = ExplanationModel.create({ type });
      }
      self.explanation.detailExplanation = JSON.stringify(detailExplanation);
    },
  }))
  .views((self) => {
    const isCompletedFn = () => self?.explanation?.isCompleted || false;
    const isDirtyFn = () => self?.explanation?.isDirty || false;
    return {
      get isCompleted(): boolean {
        return self?.explanation?.isCompleted || false;
      },
      get isDirty(): boolean {
        return self?.explanation?.isDirty || false;
      },
      isCompletedFn,
      isDirtyFn,
    };
  });

